<template>
    <Modal
        ref="modal"
        name="settings:credit:credit-modal"
        :width="700"
        @closed="useEvent('settings:credit:credit-modal:close')"
    >
        <div
            v-if="creditData"
            class="p-4"
        >
            <ModalLoader v-if="loading" />
            <div class="flex flex-col gap-6">
                <h3 class="text-center text-2xl font-normal mb-6">{{ $t('settings.credit.buy') }}</h3>
                <SettingsCreditBasket :available-credits="creditData.available" />
                <SettingsCreditBuy
                    :credit-price="creditData.cost"
                    @purchased="getCreditData"
                />
                <SettingsCreditAutomaticBuy :automated-purchase="creditData.automatedPurchase" />
            </div>
        </div>
    </Modal>
</template>

<script lang="ts" setup>
    const { getCreditData, creditData } = useCreditData();

    const loading = ref(false);

    useModal('settings:credit:credit-modal');

    onBeforeMount(async () => {
        loading.value = true;
        await getCreditData();
        loading.value = false;
    });
</script>
